import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { normaliseCostTableName } from '../utils/normaliseCostTableName';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const costTablesStoreSelector = createSelector(
  parseNamespace,
  state => state.CostTablesStore
);

const costTableNamesSelector = createSelector(
  costTablesStoreSelector,
  store =>
    new Set(
      store.costTablesOverview.rows.map(ct => normaliseCostTableName(ct.name))
    )
);

export const useCostTableNames = () => useSelector(costTableNamesSelector);
